<template>
    <div class="row">
        <div class="col-md-8 col-12" >
        <table class="table table-borderless">
            <tr>
              <th>Form</th>
              <th>Status</th>
            <th v-if="actionType">Action</th>
            </tr>
            <tr v-for="(taskForm, index) in taskForms" :key="index">
              <td>
                {{ taskForm.form.name }}
                <div class="progress" v-html="progressHtmlRender(formProgress[taskForm.id])"></div>
              </td>
              <td>
                <span v-if="taskForm.response_status">{{ taskForm.response_status }}</span>
              </td>
            <td v-if="actionType">
                <a :href="updateTaskFormResponseUrl(task_id,taskForm.form_id, taskForm.form_body_id, taskForm.id)"
                   class="btn btn-sm btn-success " target="_blank">Save Your Response</a>
            </td>
            </tr>
            <tr v-if="taskForms.length == 0">
            <td colspan="2">No Forms</td>
            </tr>
        </table>
        </div>
        <div class="col-md-4 col-12 form-progress">
            <app-widget
            class="mt-5"
            :type="'app-widget-with-circle'"
            label="Forms Progress"
            :number="(overallProgress)"
            />
        </div>
    </div>
</template>

<script>

export default {
  name: "FormProgress",

  props: {
    taskForms: Array,
    formProgress: Object,
    overallProgress: Number,
    task_id: Number,
    actionType: Boolean,
  },
  data() {
    return {
        totalPercentage: 0,
    };
  },

  methods: {
    progressHtmlRender(value) {
      return `<div class="progress-bar progress-style" role="progressbar" style="width: ${value}%;" aria-valuenow="${value}" aria-valuemin="0" aria-valuemax="100">${value}</div>`;
    },
    updateTaskFormResponseUrl(taskId, form_id, form_body_id, form_revision_id) {
      return (
          '/taskFormResponse/save/' +
          form_body_id +
          '/?form_id=' +
         form_id +
          '&task_id=' +
          taskId +
          '&form_revision_id=' +
          form_revision_id +
          '&type=save_response&user_id=' +
          this.userId +'&new_tab=yes'
      );
    },
  },
  computed: {
    userId() {
      return this.$store.state.user.loggedInUser.id;
    },
  },
};
</script>
<style>
.progress-style {
  text-align: center !important;
  /* color: #fff !important; */
  font-weight: bold !important;
  /* background-color: #292f4c !important; */
}

.form-progress .progress{
    width: 150px;
    height: 150px;
    line-height: 150px;
    background: none;
    margin: 0 auto;
    box-shadow: none;
    position: relative;
}
.form-progress .progress:after{
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 12px solid #fff;
    position: absolute;
    top: 0;
    left: 0;
}
.form-progress .progress > span{
    width: 50%;
    height: 100%;
    overflow: hidden;
    position: absolute;
    top: 0;
    z-index: 1;
}
.form-progress .progress .progress-left{
    left: 0;
}
.form-progress .progress .progress-bar{
    width: 100%;
    height: 100%;
    background: none;
    border-width: 12px;
    border-style: solid;
    position: absolute;
    top: 0;
}
.form-progress .progress .progress-left .progress-bar{
    left: 100%;
    border-top-right-radius: 80px;
    border-bottom-right-radius: 80px;
    border-left: 0;
    -webkit-transform-origin: center left;
    transform-origin: center left;
}
.form-progress .progress .progress-right{
    right: 0;
}
.form-progress .progress .progress-right .progress-bar{
    left: -100%;
    border-top-left-radius: 80px;
    border-bottom-left-radius: 80px;
    border-right: 0;
    -webkit-transform-origin: center right;
    transform-origin: center right;
    animation: loading-1 1.8s linear forwards;
}
.form-progress .card.card-with-shadow {
  box-shadow: none !important;
}
/* .form-progress .progress .progress-value{
    width: 30%;
    height: 330%;
    border-radius: 50%;
    background: #ffffff;
    font-size: 24px;
    color: #d10b4f;
    line-height: 135px;
    text-align: center;
    position: absolute;
    top: 5%;
    left: 5%;
}
.form-progress .progress.blue .progress-bar{
    border-color: #d10b4f;
}
.form-progress .progress.blue .progress-left .progress-bar{
    animation: loading-2 1.5s linear forwards 1.8s;
}






@keyframes loading-1{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
    }
}
@keyframes loading-2{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(144deg);
        transform: rotate(144deg);
    }
}
@keyframes loading-3{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
    }
}
@keyframes loading-4{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(36deg);
        transform: rotate(36deg);
    }
}
@keyframes loading-5{
    0%{
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100%{
        -webkit-transform: rotate(126deg);
        transform: rotate(126deg);
    }
}
@media only screen and (max-width: 990px){
    .progress{ margin-bottom: 20px; }
} */
</style>